import { render, staticRenderFns } from "./mrc_ess_dictName.vue?vue&type=template&id=5487b001&scoped=true&"
import script from "./mrc_ess_dictName.vue?vue&type=script&lang=js&"
export * from "./mrc_ess_dictName.vue?vue&type=script&lang=js&"
import style0 from "./mrc_ess_dictName.vue?vue&type=style&index=0&id=5487b001&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5487b001",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VCheckbox,VChip,VImg,VListItemContent})
